var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-media',{attrs:{"tag":"li"}},[_c('div',{staticClass:"text-left"},[_c('p',[_c('strong',[_vm._v("Countries")]),_vm._v(": "+_vm._s(_vm.defineCountries(this.countries))+".\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f3cb3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recipes/RecipeCountry.vue
// module id = null
// module chunks = 